module.exports = __webpack_public_path__ + "static/profile-f42f208808b9876a1766d00e8e546244.png";